import axios from "./axios-common";
const DEBUG=true;

class DashboardService {
  fetch(pObj) {
    if(DEBUG) console.debug('DashboardService.fetch',pObj);
    const payload = {
          servisID: pObj.user.servis_id,
          userID:   pObj.user.user_id,
          spz:      pObj.spz,
          other:    pObj.other,
          daysBack: pObj.daysBack,
          filter:   pObj.filter,
          tabControl: pObj.tabControl,
    };
    if(DEBUG) console.debug('DashboardService.fetch payload',payload);
    return axios
      //.post('/api/dash', payload)
      .get('/api/dash', { params: { ...payload }} )
      .then(response => {
        // axios returns config/data/headers/request/ status/statusText
        if(DEBUG) console.debug('DashboardService:', response.status, response?.data?.table, response?.data?.message);
        if(response.data.success){
            // whole data obj from rest {success,totalRows,data}
            console.log(`DashboardService received ${response.data.table.length} rows.`);
            return response.data;
        } else {
            throw response.data.error;
        }
        
      })
      .catch(err=>{
        throw err;
      });
  }

  fetchLogs(pObj){
    if(DEBUG) console.debug('DashboardService.fetchLogs running axios for dashID:',pObj.dashID);
    return axios
      .get('/api/dash/getLogs', { params: {
            servisID: pObj.user.servis_id,
            userID:   pObj.user.user_id,
            dashID:   pObj.dashID,
        }})
      .then(response => {
        if(DEBUG) console.debug('DashboardService->fetchLogs:', response.status, response?.data?.appLog?.length, response?.data?.wrkLog?.length);
        if(response.data.success){
            // whole data obj from rest {success,totalRows,data}
            console.log(`DashboardService->fetchLogs received ${response.data.appLog?.length} and ${response.data.wrkLog?.length} rows.`);
            return response.data;
        } else {
            throw response.data.error;
        }
        
      })
      .catch(err=>{
        throw err;
      });
  }

  runAction(pObj){
    return axios
      .post('/api/dash/runAction', {
          servisID: pObj.user.servis_id,
          userID:   pObj.user.user_id,
          action:   pObj.action,
          dashID:   pObj.dashID,
          data:     pObj.data,
      })
      .then(response => {
        if(response?.data?.success){
            console.log(`DashboardService->runAction received ${JSON.stringify(response.data)}`);
            return response.data;
        } else {
            throw response.data?.error;
        }
      })
      .catch(err=>{ throw err; });
  }

  setAction(pObj){
    const payload = {
          servisID: pObj.user.servis_id,
          userID:   pObj.user.user_id,
          id:       pObj.id,
          action:   pObj.action,
          data:     pObj.data,
    };
    return axios
      .post('/api/dash', payload)
      .then(response =>{
        if(DEBUG) console.log('setAction:', response);
        return response.data;
      });
  }

  adminCommand(pObj){
    return axios
      .post('/api/dash/runAdminCommand', {
          servisID: pObj.user.servis_id,
          userID:   pObj.user.user_id,
          jobID:    pObj.jobID,
          command:  pObj.command,
          data:     pObj.data,
      })
      .then(response => {
        if(response?.data?.success){
            console.log(`DashboardService->adminCommand received ${JSON.stringify(response.data)}`);
            return response.data;
        } else {
            throw response.data?.error;
        }
      })
      .catch(err=>{ throw err; });
  }

}

export default new DashboardService();